import BasicCrudScreenType from "../screenTypes/functional/BasicCrudScreenType";

function ApprovalTypeManage ( props ) {

    return <BasicCrudScreenType id="ApprovalType" table="ApprovalType" view="VwApprovalType" />

}

export default ApprovalTypeManage;
